module.exports = __webpack_public_path__ + "img/addList.5e3a7de2.svg";